import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// qs
import qs from 'qs'
Vue.prototype.$qs = qs

// element
import element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import 'element-ui/lib/theme-custom/index.css'
Vue.use(element)

// axios
import axios from 'axios'
axios.defaults.timeout = 120 * 1000
axios.interceptors.request.use(
    config => {
        config.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.hemutx.com/' : null
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: store.state.token,
            ...config.headers
        }
        return config
    },
    err => {
        return Promise.reject(err)
    }
)
axios.interceptors.response.use(
    response => {
        if (response.status.toString().charAt(0) == 2) {
            return response.data
        }
    },
    error => {
        if (error && error.response) {
            switch (error.response.status) {
                case 401:
                    router.replace({
                        path: '/login'
                    })
                    Vue.prototype.$message.error(error.response.data.message || '身份验证失败！')
                    break
                case 403:
                    router.push({
                        path: '/403'
                    })
                    Vue.prototype.$message.error(error.response.data.message || '权限不足！')
                    break
                case 404:
                    router.push({
                        path: '/404'
                    })
                    Vue.prototype.$message.error(error.response.data.message || '找不到文件！')
                    break
                case 406:
                    router.replace({
                        path: '/login'
                    })
                    Vue.prototype.$message.error(error.response.data.message)
                    break
                case 407:
                    router.replace({
                        path: '/login'
                    })
                    Vue.prototype.$message.error(error.response.data.message)
                    break
                case 422:
                    Vue.prototype.$message.error(error.response.data.message)
                    break
                case 500:
                    Vue.prototype.$message.error(error.response.data.message || '服务器错误，请稍后重试！')
                    break
                default:
                    return Promise.reject(error)
            }
        }
    }
)
Vue.prototype.$axios = axios

import moment from 'moment'
moment.locale('zh-ch')
Vue.prototype.$moment = moment

// 复制功能
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 全局方法
import utils from './utils'
Vue.use(utils)

// 导航守卫
router.beforeEach((to, from, next) => {
    if (
        store.state.token ||
        to.path === '/login' ||
        to.path === '/register' ||
        to.path === '/tools' ||
        to.path === '/pay'
    ) {
        next()
    } else {
        next({
            path: '/login'
        })
    }
})
router.afterEach(to => {
    window.document.title = to.name
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
